import { z } from 'zod';

import { selectableAnswerSlideItemSchema } from './selectableAnswerSlideItemSchema';
import { textAnswerSlideItemSchema } from './textAnswerSlideItemSchema';

export const answerSlideItemSchema = z.union([
  selectableAnswerSlideItemSchema,
  textAnswerSlideItemSchema,
]);

export type AnswerSlideItemType = z.infer<typeof answerSlideItemSchema>;
